import { FC, useContext, useEffect, useState } from "react";
import { Col, Row } from "../../components/grid";
import { Section } from "../../components/layout/Section";
import { Image } from "../../components/media/Image";
import { Paragraph } from "../../components/typography/Paragraph";
import { fetchAbout } from "../../data/data";
import { AppContext } from "./Profile";
import styles from "./About.module.scss";

export const About: FC = () => {
  const [data, setData] = useState<string[] | null>(null);
  const { isMobile, keys, markSectionLoaded } = useContext(AppContext);
  useEffect(() => {
    fetchAbout().then((response) => {
      setData(response);
      markSectionLoaded("about");
    });
  }, [markSectionLoaded]);

  return (
    <Section title="About" busy={!data}>
      <Row gutter={isMobile ? ["regular", "regular"] : ["large", "large"]}>
        <Col
          xs={isMobile ? 24 : 7}
          sm={isMobile ? undefined : 6}
          md={isMobile ? undefined : 5}
          align={[isMobile ? "left" : "right", "top"]}
        >
          <div className={isMobile ? styles.imageWrap : undefined}>
            <Image
              src={keys?.profileImageUrl}
              className={styles.image}
            />
          </div>
        </Col>
        <Col xs={isMobile ? 24 : 17} sm={isMobile ? undefined : 18} md={18}>
          {data?.map((entry: string, idx: number) => (
            <Paragraph key={idx}>{entry}</Paragraph>
          ))}
        </Col>
      </Row>
    </Section>
  );
};
